import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const NudgeContext = createContext(null);

export function NudgeProvider({ children }) {
  const [nudge, setNudge] = useState(null);

  const showNudge = useCallback((next) => {
    setNudge({
      title: next?.title || 'Upgrade required',
      message: next?.message || 'This feature is not available on your current plan.',
    });
  }, []);

  const hideNudge = useCallback(() => setNudge(null), []);

  const value = useMemo(() => ({ showNudge, hideNudge }), [hideNudge, showNudge]);

  return (
    <NudgeContext.Provider value={value}>
      {children}
      {nudge && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: 16,
          }}
          onClick={hideNudge}
        >
          <div
            style={{
              width: 'min(560px, 100%)',
              background: '#0b1220',
              border: '1px solid #334155',
              borderRadius: 12,
              padding: 16,
              color: '#e5e7eb',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
              <h3 style={{ margin: 0 }}>{nudge.title}</h3>
              <button type="button" onClick={hideNudge}>
                Close
              </button>
            </div>
            <p style={{ marginTop: 10, color: '#cbd5e1' }}>{nudge.message}</p>
          </div>
        </div>
      )}
    </NudgeContext.Provider>
  );
}

export function useNudge() {
  const ctx = useContext(NudgeContext);
  if (!ctx) throw new Error('useNudge must be used within a NudgeProvider');
  return ctx;
}

